import { render, staticRenderFns } from "./DistributionOverview.vue?vue&type=template&id=1f5269b8&scoped=true&"
import script from "./DistributionOverview.vue?vue&type=script&lang=js&"
export * from "./DistributionOverview.vue?vue&type=script&lang=js&"
import style0 from "./DistributionOverview.vue?vue&type=style&index=0&id=1f5269b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5269b8",
  null
  
)

export default component.exports